import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_54eaf879";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_54eaf879" };
/** script content **/
require("./nav-item-content.mpx.ts?isComponent&outputPath=components%2Fnav-item-content54eaf879%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./nav-item-content.mpx?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Fnav-item-content54eaf879%2Findex&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_54eaf879"],
    ctorType: "component",
    outputPath: "components/nav-item-content54eaf879/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'mpx-rich-text': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-rich-text?isComponent"), { __mpxBuiltIn: true }) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
